import React, { useEffect, useState } from "react";
import "../styles/db.css";
import { Button, message, Row, Table, Tooltip } from "antd";
import {
  SyncOutlined,
  RightOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import PageHeader from "../components/generic/PageHeader";
import { job_queue_summary_column_parent } from "../constants/Table Columns";
import { getAllJobs } from "../service/run.service";
import CustomLoadingIcon from "../components/generic/CustomLoadingIcon";

function JobQueue(props) {
  const navigate = useNavigate();
  const [jobData, setJobData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);

  useEffect(() => {
    getAllJobs()
      .then((res) => {
        setJobData(res.data);
      })
      .catch((error) => {
        message.error(`Unable to retrieve job data - ${error}`);
      })
      .finally(() => {
        setTableLoading(false);
      });
  }, []);

  const onClickRefresh = () => {
    getAllJobs()
      .then((res) => {
        setJobData(res.data);
      })
      .catch((error) => {
        message.error(`Unable to retrieve job data - ${error}`);
      })
      .finally(() => {
        setTableLoading(false);
      });
  };

  const parentJobs = jobData.filter(
    (job) => !job.parentJobId || job.parentJobId === "Not Applicable"
  );

  // Master Suite rows drill into a dedicated Job Details page via a chevron
  // "go to" icon at the end of the row; all existing columns stay untouched.
  const parentColumns = [
    ...job_queue_summary_column_parent,
    {
      title: "",
      key: "drilldown",
      width: 56,
      align: "center",
      render: (_, record) =>
        record.taskType === "Master Suite" ? (
          <Tooltip title="View steps">
            <Button
              type="text"
              shape="circle"
              icon={<RightOutlined />}
              onClick={() =>
                navigate("/jobs/details", { state: { jobId: record.jobId } })
              }
              style={{ color: "#185FA5" }}
            />
          </Tooltip>
        ) : null,
    },
  ];

  return (
    <div className="db-container">
      <PageHeader
        backTo="/admin"
        icon={<UnorderedListOutlined />}
        title="Job Queue"
        tooltip="All job runs — reconciliations, master suites and UI tests"
        actions={
          <Button
            className="db-add"
            icon={<SyncOutlined />}
            onClick={onClickRefresh}
          >
            Refresh
          </Button>
        }
      />
      <Row className="table-container">
        <Table
          columns={parentColumns}
          dataSource={parentJobs}
          rowKey="jobId"
          loading={{
            spinning: tableLoading,
            indicator: <CustomLoadingIcon />,
          }}
          pagination={{
            defaultPageSize: 20,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "30"],
          }}
        />
      </Row>
    </div>
  );
}

export default JobQueue;
